import React from 'react'
import { Tooltip, IconButton, Stack } from '@mui/material'
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';

function RowDelete({rows, setRows, rowId, hoveredRow, handleDelete, deleteRowParts}) {


    // Function to delete a row by ID
    const deleteRow = (sl) => {
            const id = rows.find(item=> item.id===sl).labourId
            if(id){
                handleDelete(id)
            }          
            const updatedRows = rows.filter((row) => row.labourId !== id);
        
            // After filtering, reassign consecutive IDs to the rows
            const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
              ...row,
              id: index + 1,
            }));
        
            setRows(updatedRowsWithConsecutiveIDs);
            deleteRowParts(id,null)
        //   else {
        //     // If there's only one row left, reset its ID to 1
        //     setRows([{ id: 1, name: '' }]);
        //   }
    };

    return (
        <Stack direction='row' spacing={1}>
            {rowId === hoveredRow &&
             <Tooltip title="Remove">
             <IconButton size='small' onClick={() => { deleteRow(rowId) }} >
             <RemoveCircleOutlinedIcon />
             </IconButton>
         </Tooltip>
            }
           
        </Stack>
    )
}

export default RowDelete